/* unplugin-vue-components disabled */import { render } from "./UserLocation.vue?vue&type=template&id=4360aa9e&scoped=true"
import script from "./UserLocation.vue?vue&type=script&lang=js"
export * from "./UserLocation.vue?vue&type=script&lang=js"

import "./UserLocation.vue?vue&type=style&index=0&id=4360aa9e&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4360aa9e"]])

export default __exports__